import { EmptyState, NoTasksIcon } from '@bp/ui-components';
import { useHomeworkEvents } from 'components/Events/hooks/useHomeworkEvents';
import { Dayjs } from 'dayjs';
import { useTranslation } from 'react-i18next';
import { HomeworkCard } from '../HomeworkCard/HomeworkCard';
import styles from './HomeworkList.module.scss';

type HomeworkListProps = { profileUuid: string; selectedDay: Dayjs };

export const HomeworkList = ({ profileUuid, selectedDay }: HomeworkListProps) => {
  const { t } = useTranslation();

  const { homeworkEvents } = useHomeworkEvents({
    profileUuid,
    timespan: { start: selectedDay.toDate(), end: selectedDay.toDate() },
  });

  return (
    <div className={styles['homework-list']}>
      {homeworkEvents.length === 0 ? (
        <EmptyState forcedHeight='50vh' title={t('homeworks.noHomeworkForToday')} icon={<NoTasksIcon />} />
      ) : (
        homeworkEvents.map((event) => (
          <HomeworkCard
            key={event.uuid}
            uuid={event.uuid}
            eventName={event.title}
            subjectName={event.subject.name}
            homework={event.homework}
            className={styles.homework}
          />
        ))
      )}
    </div>
  );
};
